import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import {
  Card,
  CardHeader,
  CardBody,
  CardHeaderToolbar,
} from '../../../../../_metronic/_partials/controls/Card';
import ModalConfirm from '../../../../components/ModalConfirm';
import { CouponStatusBadge } from '../_components/CouponStatusBadge';
import { CouponDiscountsTable } from '../_components/CouponDiscountsTable';
import { useCouponDetailsBootstrap } from './coupon-details.bootstrap.hook';

function formatDate(value) {
  if (!value) return '-';
  return format(parseISO(value), 'dd/MM/yyyy');
}

function DetailRow({ label, children }) {
  return (
    <div
      className="d-flex justify-content-between align-items-center"
      style={{ padding: '10px 0', borderBottom: '1px solid #f4f4f4' }}
    >
      <span style={{ color: '#838486', fontSize: '13px' }}>{label}</span>
      <span style={{ textAlign: 'right' }}>{children}</span>
    </div>
  );
}

export default function CouponDetailsV2(props) {
  const couponId = props.match.params.id;
  const {
    coupon,
    confirmAction,
    setConfirmAction,
    loading,
    fetchingCoupon,
    goToEdit,
    goToList,
    handleExpire,
    handleDelete,
  } = useCouponDetailsBootstrap(couponId, props.location.state?.coupon);

  const discounts = coupon?.discounts ?? [];

  if (!coupon) {
    return (
      <div>
        <span>
          {fetchingCoupon
            ? 'Carregando dados do cupom...'
            : 'Não foi possível carregar os dados do cupom. Volte para a listagem e tente novamente.'}
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="mb-5">
        <span
          role="button"
          tabIndex={0}
          onClick={goToList}
          style={{ cursor: 'pointer', color: '#838486', fontSize: '13px' }}
        >
          &lt; Painel ADMIN
        </span>
        <span style={{ color: '#838486', fontSize: '13px' }}>
          {' '}
          &bull; Cupons JusSub
        </span>
      </div>

      <Card>
        <CardHeader title="Detalhes do Cupom">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-outline-primary btn-sm mr-2"
              onClick={goToEdit}
            >
              Editar
            </button>
            <Dropdown alignRight>
              <Dropdown.Toggle
                bsPrefix="coupon-actions-toggle"
                variant="link"
                className="btn btn-light btn-icon btn-sm"
                id="coupon-details-actions"
              >
                <i className="ki ki-bold-more-ver"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-sm">
                <Dropdown.Item onClick={() => setConfirmAction('expire')}>
                  Expirar cupom
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setConfirmAction('delete')}
                  style={{ color: '#dc3545' }}
                >
                  Excluir cupom
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <DetailRow label="Status">
            <CouponStatusBadge coupon={coupon} />
          </DetailRow>
          <DetailRow label="Nome do cupom">{coupon.code}</DetailRow>
          <DetailRow label="Data de início">
            {formatDate(coupon.startsAt)}
          </DetailRow>
          <DetailRow label="Data de expiração">
            {formatDate(coupon.expiresAt)}
          </DetailRow>
          <DetailRow label="Ciclo">
            {coupon.cyclesCount}{' '}
            {Number(coupon.cyclesCount) === 1 ? 'ciclo' : 'ciclos'}
          </DetailRow>
        </CardBody>
      </Card>

      <Card>
        <CardHeader title="Descontos" />
        <CardBody>
          <CouponDiscountsTable discounts={discounts} />
        </CardBody>
      </Card>

      <Card>
        <CardHeader title="Histórico" />
        <CardBody>
          <span style={{ background: '#EDC79B' }}>Em breve!</span>
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table">
              <thead>
                <tr
                  style={{
                    color: '#838486',
                    fontSize: '12px',
                    textTransform: 'uppercase',
                  }}
                >
                  <th>Alterado por</th>
                  <th>E-mail</th>
                  <th>Alteração</th>
                  <th>Alterado em</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    Sem histórico disponível
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>

      {confirmAction === 'expire' && (
        <ModalConfirm
          title="Expirar cupom"
          message="Tem certeza que deseja expirar este cupom? Ele deixará de ser aplicável."
          onConfirm={handleExpire}
          onClose={() => setConfirmAction(null)}
          isLoading={loading}
        />
      )}

      {confirmAction === 'delete' && (
        <ModalConfirm
          title="Excluir cupom"
          message="Tem certeza que deseja excluir este cupom? Esta ação não pode ser desfeita."
          onConfirm={handleDelete}
          onClose={() => setConfirmAction(null)}
          isLoading={loading}
        />
      )}
    </>
  );
}
